<template>
  <screen
    v-show="show"
    :screen-name="$t('mobileScan.begin_title')"
    :screen-info="$t('mobileScan.begin_info')"
    :can-skip="false"
    @leave="$emit('leave')"
    center-titles
    purple-title
  >
    <img src="../../../assets/MobileScan/before-scan.svg" :alt="$t('mobileScan.begin_info')" />
    <c-button class="tall:mt-10" @click="$emit('next')">
      <span>{{ $t('mobileScan.start_tutorial') }}</span>
    </c-button>
    <p class="skip">
      <span>{{ $t('mobileScan.not_first') }}</span>
      <a class="underline" href="#" @click="$emit('skip')">{{ $t('mobileScan.skip_tutorial') }}</a>
    </p>
  </screen>
</template>

<script>
import Screen from '@/components/common/Screen.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'Begin',
  components: {
    Screen,
    CButton,
  },
  props: {
    show: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.skip {
  @apply text-xs mt-4;
  span {
    color: rgba(38, 38, 38, 0.6);
  }
  a {
    @apply mx-2;
  }
}
</style>
